import {
  styled,
  FormHelperText,
  createTheme,
  Paper,
  Grid,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import { MenuButton as BaseMenuButton } from "@mui/base/MenuButton";
import { MenuItem as BaseMenuItem, menuItemClasses } from "@mui/base/MenuItem";
export const LinkTo = styled(Link)({ color: "white", textDecoration: "none" });
export const StarSymbol = styled("span")({ color: "rgb(211,56,86)" });
export const ErrorMessage = styled(FormHelperText)({
  color: "red",
  fontSize: "10px",
  marginBottom: 2,
});

export const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2", // Primary color
    },
    secondary: {
      main: "#dc004e", // Secondary color
    },
    info: {
      main: "#17a2b8", // Info color
    },
    success: {
      main: "#28a745", // Success color
    },
    warning: {
      main: "#ffc107", // Warning color
    },
    error: {
      main: "#dc3545", // Error color
    },
    // Add custom colors if needed
    customBlue: {
      main: "#1e88e5",
      contrastText: "#ffffff", // Text color on this background
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 575,
      md: 768,
      lg: 991,
      xl: 1200,
    },
  },
});

export const GridItem = styled("Box")({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: { xs: "start", sm: "center" },
});
export const ButtonGrid = styled("Grid")({
  display: "flex",
  justifyContent: "end",
});
export const FormHelperTexts = styled(FormHelperText)({
  fontSize: "10px",
  marginBottom: "10px",
});

const blue = {
  50: "#F0F7FF",
  100: "#C2E0FF",
  200: "#99CCF3",
  300: "#66B2FF",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E6",
  700: "#0059B3",
  800: "#004C99",
  900: "#003A75",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

export const Listbox = styled("ul")(
  ({ theme }) => `
   
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    box-sizing: border-box;
    padding: 6px;
    margin: 12px 0;
    
 margin: 5px 0;
  max-width: 200px; /* Prevent horizontal overflow */
    max-height: 200px; /* Limit height to enable scrolling */
    border-radius: 12px;
    overflow-y: auto; /* Enable vertical scrolling */
    overflow-x: hidden; /* Prevent horizontal scrolling */
    outline: 0;
    background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    box-shadow: 0 4px 6px ${theme.palette.mode === "dark" ? "rgba(0,0,0, 0.50)" : "rgba(0,0,0, 0.05)"
    };
    z-index: 1;

    /* Add a custom scrollbar style */
    scrollbar-width: thin; /* For Firefox */
    scrollbar-color: ${theme.palette.mode === "dark" ? grey[700] : grey[300]
    } transparent;

    &::-webkit-scrollbar {
      width: 6px; /* Width of the scrollbar */
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.palette.mode === "dark" ? grey[700] : grey[300]
    }; /* Scrollbar color */
      border-radius: 12px; /* Rounded corners */
    }

    &::-webkit-scrollbar-thumb:hover {
      background: ${theme.palette.mode === "dark" ? grey[600] : grey[400]
    }; /* Hover color */
    }

    &::-webkit-scrollbar-track {
      background: transparent; /* Track color */
    }
  `
);

export const MenuItem = styled(BaseMenuItem)(
  ({ theme }) => `
    list-style: none;
    padding: 8px;
    border-radius
    cursor: default;
    user-select: none;
    max-width: 150px; /* Prevent infinite width */
     
    &:last-of-type {
      border-bottom: none;
    }
  
    &:focus {
      outline: 3px solid ${theme.palette.mode === "dark" ? blue[600] : blue[200]
    };
      background-color: ${theme.palette.mode === "dark" ? grey[800] : grey[100]
    };
      color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    }
  
    &.${menuItemClasses.disabled} {
      color: ${theme.palette.mode === "dark" ? grey[700] : grey[400]};
    }
    `
);

export const StyledBox = styled(Box)(({ theme, isAuthenticated }) => ({
  flexGrow: 1,
  height: isAuthenticated ? "calc(100vh - 60px)" : "100vh",
  overflowY: "auto",
  backgroundColor: isAuthenticated ? "#f8f5f5" : "#ffffff",
}));
export const MenuButton = styled(BaseMenuButton)(
  ({ theme }) => `
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.5;
    width:110px;
    max-width:110px;
    display:flex;
    justify-content:space-between;
    align-items:center;
    background:#ccc;
    padding:7px 8px;
 
    transition: all 150ms ease;
    cursor: pointer;
    background: ${theme.palette.mode === "dark" ? grey[900] : "#ccc"};
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    color: ${theme.palette.mode === "dark" ? grey[200] : grey[900]};
    box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  
    &:hover {
      background: ${theme.palette.mode === "dark" ? grey[800] : grey[50]};
      border-color: ${theme.palette.mode === "dark" ? grey[600] : grey[300]};
    }
  
    &:active {
      background: ${theme.palette.mode === "dark" ? grey[700] : grey[100]};
    }
  
    &:focus-visible {
      box-shadow: 0 0 0 4px ${theme.palette.mode === "dark" ? blue[300] : blue[200]
    };
      outline: none;
    }
    `
);

export const formatDateWithAmPm = (dateString) => {
  if (!dateString) return "-";
  
  const date = new Date(dateString);
  if (isNaN(date)) return "-";
  
  // Better regex to detect time component in various formats
  // Matches patterns like: T12:34, 12:34:56, T12:34:56, space12:34, etc.
  const hasTimeComponent = /[T\s]\d{1,2}:\d{2}(:\d{2})?/.test(dateString);
  
  if (hasTimeComponent) {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      // Remove timeZone: "UTC" to use local timezone
    };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  } else {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      // Remove timeZone: "UTC" to use local timezone
    };
    return new Intl.DateTimeFormat("en-GB", options).format(date);
  }
};


export const formatDateWithAmPmBooking = (dateString) => {
  if (!dateString || typeof dateString !== "string") return "-";

  // Try to parse into Date
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "-";

  // Detect if time exists in the original string
  const hasTimeComponent = /\d{2}:\d{2}/.test(dateString);

  const options = hasTimeComponent
    ? {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }
    : {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };

  return new Intl.DateTimeFormat("en-GB", options).format(date);
};
export const convertTo12HourFormat = (time24) => {
  if (!time24 || typeof time24 !== "string") return "-";

  const [hoursStr, minutesStr] = time24.split(":");
  let hours = parseInt(hoursStr, 10);
  const minutes = minutesStr || "00";

  if (isNaN(hours)) return "-";

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // convert 0 → 12, 13 → 1, etc.

  return `${hours}:${minutes} ${ampm}`;
};



export const convertDateFormatBooking = (dateString) => {
  if (!dateString) return null;
  const [day, month, year] = dateString.split("-");
  return `${year}-${month}-${day}`;
};

export const convertDateOfBirthFormat = (dateString) => {
  if (!dateString) return "";

  try {
    // Handle the format "17-07-2001 05:30:00 AM"
    if (dateString.includes("-") && dateString.includes(":")) {
      const [datePart] = dateString.split(" ");
      const [day, month, year] = datePart.split("-");
      // Return in YYYY-MM-DD format or whatever format your backend expects
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    // Handle other date formats
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "";
    }

    // Return in YYYY-MM-DD format
    return date.toISOString().split('T')[0];
  } catch (error) {
    console.error("Error converting date:", error);
    return "";
  }
};

export const convertProfileDOBFormat = (dateString) => {
  if (!dateString) return "";

  try {
    // Check if the date is in DD-MM-YYYY format (e.g. from the DatePicker)
    const dmyPattern = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
    const match = dateString.match(dmyPattern);
    
    if (match) {
      const [_, day, month, year] = match;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    // Handle the format "17-07-2001 05:30:00 AM"
    if (dateString.includes("-") && dateString.includes(":")) {
      const [datePart] = dateString.split(" ");
      const [day, month, year] = datePart.split("-");
      // Return in YYYY-MM-DD format or whatever format your backend expects
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    // Handle other date formats
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "";
    }

    // Return in YYYY-MM-DD format
    return date.toISOString().split('T')[0];
  } catch (error) {
    console.error("Error converting date:", error);
    return "";
  }
};
const normalizeDate = (dateStr) => {
  if (!dateStr) return "";
  return dateStr.replace(/\//g, "-"); // Convert all "/" to "-"
};

export const convertDateFormat = (dateString) => {
  if (!dateString) return null;
  dateString = normalizeDate(dateString);
    console.log("dateString", dateString)
  // ✅ If already in YYYY-MM-DD format, just return it
  const isoPattern = /^\d{4}-\d{2}-\d{2}$/;
  if (isoPattern.test(dateString)) {
  
    return dateString;
  }

  // ✅ Check if the date is in DD-MM-YYYY format
  const dmyPattern = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
  const match = dateString.match(dmyPattern);

  if (match) {
    const [_, day, month, year] = match;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  // ✅ For other formats, try parsing safely
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return null; // Invalid date

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error("Error converting date:", error);
    return null;
  }
};

export const convertStaffDateFormat = (dateString) => {
  if (!dateString) return null;

  // Check if the date is in DD/MM/YYYY format with slashes
  const slashPattern = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
  const slashMatch = dateString.match(slashPattern);

  if (slashMatch) {
    // If the date is in DD/MM/YYYY format with slashes, convert to YYYY-MM-DD
    const [_, day, month, year] = slashMatch;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  // Keep the existing check for dates with hyphens
  const hyphenPattern = /^(\d{1,2})-(\d{1,2})-(\d{4})$/;
  const hyphenMatch = dateString.match(hyphenPattern);

  if (hyphenMatch) {
    const [_, day, month, year] = hyphenMatch;
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  // Fallback to Date object parsing
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return null; // Invalid date
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  } catch (error) {
    console.error("Error converting date:", error);
    return null;
  }
};
export const getStatusClass = (status) => {
  const statusClassMap = {
    Active: "badge-active",
    Approved: "badge-active",
    completed: "badge-active",
    Completed: "badge-active",
    Pending: "badge-pending",
    Inactive: "badge-inactive",
    Rejected: "badge-inactive",
    Receptionist: "badge-receptionist",
    Manager: "badge-manager",
    Failed: "badge-failed",
  };

  return statusClassMap[status] || "badge-default";
};

// export const columnFetcher = (column) => {
//   const columns = column[0];
//   const column_name = Object.keys(columns);
//   const value = column_name.map((name) => name);
//   const label = column_name.map((name) =>
//     name.toUpperCase().replaceAll("_", " ")
//   );

//   return [value, label];
// };

export const columnFetcher = (column) => {
  if (!Array.isArray(column) || column.length === 0) {
    return [];
  }

  const columns = column[0];
  const columnNames = Object.keys(columns);

  return columnNames.map((name) => ({
    value: name,
    label: name.toUpperCase().replaceAll("_", " "),
  }));
};
export const isBase64 = (str) => {
  const base64Regex =
    /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
  return base64Regex.test(str);
};
export const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }
  return age;
};

export const convertImageToBase64 = async (imageUrl) => {
  console.log("imageUrl", imageUrl)
  try {
     const proxyUrl = `https://cors-anywhere.herokuapp.com/${imageUrl}`;
    const response = await fetch(proxyUrl);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error converting image to Base64:", error);
  }
};

export const customerColumnFetcher = (customers) => {
  if (!customers || customers.length === 0) {
    return [];
  }

  const columns = Object.keys(customers[0]);
  return columns.map((key) => {
    const formattedKey = key
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (match) => match.toUpperCase());

    return {
      value: key,
      label: formattedKey,
    };
  });
};

export const vendorColumnFetcher = (vendors) => {
  if (!vendors || vendors.length === 0) {
    return [];
  }

  const columns = Object.keys(vendors[0]);
  return columns.map((key) => {
    const formattedKey = key
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/_/g, " ")
      .replace(/\b\w/g, (match) => match.toUpperCase());

    return {
      value: key,
      label: formattedKey,
    };
  });
};

export const airportColumnFetcher = (airports) => {
  if (!airports || airports.length === 0) {
    return [[], []];
  }

  const columns = airports[0];
  const columnNames = Object.keys(columns);
  const values = columnNames.map((name) => name);
  const labels = columnNames.map((name) =>
    name.toUpperCase().replaceAll("_", " ")
  );

  return [values, labels];
};

export const formatDatetimeWithAMPM = (datetimeString) => {
  const date = new Date(datetimeString);

  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const seconds = date.getSeconds().toString().padStart(2, "0");

  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  return `${day}-${month}-${year} ${hours
    .toString()
    .padStart(2, "0")}:${minutes}:${seconds} ${ampm}`;
};

export const handleApiError = (error) => {
  if (error.response) {
    const errorData = error.response.data || {};
    const errorFields = errorData.errorFields || {};
    return {
      statusCode: error.response.status,
      email: errorFields.email || null,
      phone: errorFields.phone || null,
      contact: errorFields.contact || null,
      additionalErrors: errorFields,
      message: errorData.message || "Unknown error occurred.",
    };
  } else if (error.request) {
    return {
      statusCode: null,
      message: "No response received from the server. Please try again later.",
    };
  } else {
    return {
      statusCode: null,
      message: error.message || "An unexpected error occurred.",
    };
  }
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};
